// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import {isIOS, isSafari, isMobile,isTablet, isBrowser} from 'react-device-detect';
import {CardMedia} from 'material-ui/Card';

class AddTournament extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      sub_categories: {},
      game_types: [],
      categories: {},
      age_groups: [],
      game_formats: [],
      buddies:[],
      tournament_details: {
        venue: '',
        venues: [],
        name: '',
        additional_field: '',
        game_type: '',
        start_date: moment(),
        end_date: moment(),
        category: '',
        sub_category: '',
        age_groups: [],
        game_formats: [],
        description: '',
        format_desc: '',
        prize_and_perks: '',
        registration_amount: '',
        registration_contact_number: '',
        online_registration_enabled: true,
        pay_later: false,
        is_visible:false,
        details:'',
        mobile_no:'',
        buddy_ids:[],
        banner:'',
      },
      banner_list:{
        banner: '',
        banner_one:'',
        banner_two:'',
        banner_three:'',
      },
      data_uploaded: false,
      data_error: false,
      search: false,
      details:'',
      mobile_no:'',
      buddy_search_list:[]
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleMultiselect = this.handleMultiselect.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleVenue = this.handleVenue.bind(this);
    this.getTournamentInputs = this.getTournamentInputs.bind(this);
    this.handledeleteBanner = this.handledeleteBanner.bind(this);
    this.styles = {
          chip: {
            margin: 4,
          },
          wrapper: {
            display: 'flex',
            flexWrap: 'wrap',
          },
        };
  }


  componentDidMount() {
    console.log(this.state);
  }

  componentDidMount() {
    this.getTournamentInputs();
  }

 
  getTournamentInputs() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_structure/`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {

         var tournament_details_copy =  Object.assign({}, this.state.tournament_details);
         tournament_details_copy['venue'] = data.venues[0].id;
         this.setState(          
         { 
            venues: data.venues,tournament_details: tournament_details_copy,tournament_series: data.tournament_series,
            game_types:data.game_types
         });
        },()=>this.setData())
       .catch(error => error);
  }  

  setData(){
    var images = Object.assign({}, this.state.banner_list);
    images['banner'] = this.state.tournament_details.banner
    images['banner_one'] = this.state.tournament_details.banner_extra_1
    images['banner_two'] = this.state.tournament_details.banner_extra_2
    images['banner_three'] = this.state.tournament_details.banner_extra_3

    this.setState({banner_list:images});
  }

  getSearchList() {
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({buddy_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
  setSearch(name, buddy_id, mobile_no,event){
    event.preventDefault();
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    var buddies = Object.assign([], this.state.buddies);
    buddies.push({'id': buddy_id, 'name': name, 'photo': "http://www.sporthood.in/assets/img/avatar.png"});
    if(new_selected_one['buddy_ids'].includes(buddy_id)){
      alert("Coordinator already added");
      return false;
    }
    else{
      new_selected_one['buddy_ids'].push(buddy_id)
      this.setState({tournament_details: new_selected_one, search: false,buddies: buddies});
    }
  }

  handledeleteBanner(name){
    var images = Object.assign({}, this.state.banner_list);
    if(name=='banner'){
        images['banner'] = null
    }
    else if(name=='banner_one'){
        images['banner_one'] = null
    }
    else if(name=='banner_two'){
        images['banner_two'] = null
    }
    else{
        images['banner_three'] = null
    }
    this.setState({banner_list:images})
  }

  handleRequestDelete = (key) => {
    var buddies = Object.assign([], this.state.buddies);
    const chipToDelete = buddies.findIndex(chip => chip.id==key);
    buddies.splice(chipToDelete, 1);
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    const id_index = new_selected_one['buddy_ids'].findIndex(buddy_id => buddy_id==key);
    new_selected_one['buddy_ids'].splice(id_index, 1);
    this.setState({buddies: buddies,tournament_details:new_selected_one});
  };

  renderChip(data) {
    return (
      <Chip
        key={data.id}
        onRequestDelete={() => this.handleRequestDelete(data.id)}
        style={this.styles.chip}
      >
        <Avatar id={data.id} src={data.photo=='http://www.sporthood.in/assets/img/avatar.png'?data.photo:
        `https://api.sporthood.in/${data.photo}`} />
        {data.name}
      </Chip>
    );
  }

  postaddTournament(data, props) {
    console.log(data);
    if(data.banner_extra_1==undefined){
      data.banner_extra_1 = ''
    }
    if(data.banner_extra_2==undefined){
      data.banner_extra_2= ''
    }
    if(data.banner_extra_3==undefined){
      data.banner_extra_3= ''
    }
    if(!data.additional_field){
      data.additional_field = null
    }
    const url = `${getLocationOrigin()}/eagleeye/add_tournament/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) {
      formData.append(name, data[name]);
    }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }
  handleSeries(event){
    if(event.target.value=='----Select----'){
      event.target.value = null
    }
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['tournament_series'] = event.target.value
    this.setState({tournament_details: new_selected_one});

  }

  handleChange(event) {
    const name = event.target.name;
    if(name== 'mobile_no'){
       this.setState({mobile_no:event.target.value})
    }
    else{
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.value
    this.setState({tournament_details: new_selected_one});
    }
  }
  handleMultiselect(event) {
    console.log(event);
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    var ids = []

    if(event){
       for (var i = 0, l = options.length; i < l; i++) {
      console.log(new_selected_one[name]);
              if (options[i].selected) {
                ids.push(options[i].value);
              }
          }
    }
    else{}
     new_selected_one[name] = ids; 
    this.setState({tournament_details: new_selected_one});
  }


  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['start_date'] = date
    this.setState({tournament_details: new_selected_one});
  }
  handleEndDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['end_date'] = date
    this.setState({tournament_details: new_selected_one});
  }

  handleVenue(event){
    console.log('handleVenue');
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['venue'] = event.target.value
    this.setState({tournament_details: new_selected_one});
  }  

  goBack(){
    this.props.history.goBack();
  }

  handleFile(event){
    var name = event.target.name
    var image = event.target.files[0]
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = image
    var images = Object.assign({}, this.state.banner_list);
    images[name] = window.URL.createObjectURL(image)
    this.setState({tournament_details: new_selected_one, banner_list:images});
  }

  handleCheck(event){
    console.log(event.target.name + event.target.checked)
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.checked
    this.setState({tournament_details: new_selected_one});

  }

  handleSubmit(event) {
    event.preventDefault();
    if(this.state.tournament_details.name==""){
      alert("Please add Tournament Name")
    }
    if(this.state.tournament_details.game_type==""){
      alert("Please select game type")
    }
    else{
      this.postaddTournament(this.state.tournament_details, this.props);  
    }
    
  }



  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div type="button" value="Back" style={styles.eventbutton2} onClick={() => {this.goBack()}}>X</div>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Tournament</h3>
          </div>
          <form  className="validated-form form-horizontal">

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Name *
              </div>
              <input type="text" style={styles.input} name="name" className="col-md-6 required"
                value={this.state.value} onChange={this.handleChange}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" id="venue" className="col-md-5" style={styles.item_body} value={this.state.value}
                onChange={(e) =>{this.handleVenue(e)}}>
                {
                  Object.keys(this.state.venues).map((key, index) => (
                  <option key={index} value={this.state.venues[key].id}  >{this.state.venues[key].name}</option>
                  ))
                }
              </select>              
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <select name="game_type" id="game_type" className="col-md-5" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                <option value='' >--------------</option>
                {this.state.game_types.map((game_type, index) => (
                  <option key={index} value={game_type.pk} >{game_type.game+' '+game_type.name}</option>
                  ))
                }
              </select>              
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.tournament_details.start_date} onChange={this.handleStartDate}/>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Date
              </div>
              <DatePicker  selected={this.state.tournament_details.end_date} onChange={this.handleEndDate}/>
            </div>

            <div className="col-md-12" style={styles.items}>
              <div style={styles.item_header} className="col-md-6">
                  Coordinator *
              </div>
              <div className="col-md-6 input-group" style={{width:'40%',zIndex:0}}>
                      <input type="text" name="mobile_no" className="col-md-6 form-control" 
                      placeholder="Search for.. " value={this.state.mobile_no} onChange={this.handleChange}/>
                      <span className="input-group-btn">
                      <button className="btn btn-default glyphicon glyphicon-search"
                      type="button" onClick={this.getSearchList}></button>
                      </span>
               </div>
            </div>
              {this.state.search?
                  <div className="col-md-12 btn-group">
                      {this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                  style={{padding:'1%'}} onClick={(e) => this.setSearch(x.name,x.id, x.mobile_no,e)}>{x.name}:{x.mobile_no}</button>))
                  :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                  <div className="alert alert-danger">Search customer not found</div>

              </div>
          }</div>:''}
           
            {this.state.buddies.length>0 &&
              <div className="col-md-12" style={styles.items}>
                <div style={styles.item_header} className="col-md-6">
                    Selected Coordinator(s)
                </div>
                <div className="col-md-6 input-group" style={{width:'40%'}}>
                  <div style={this.styles.wrapper}>
                    {this.state.buddies.map(this.renderChip, this)}
                  </div>
                 </div>
              </div> 
          }

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Banner(s) *
                <p style={{color:'red',fontSize:'13px'}}>Upload only 2 X 1 Images</p>
              </div>
              <div className="col-md-6" style={styles.input}>
                <div style={{display:!isMobile&&'flex'}}>
                  <div style={{padding:'3%'}}>
                    {!this.state.banner_list.banner &&<input type="file" style={{width:'80%'}} name="banner" onChange={(e) => this.handleFile(e)}/>}
                    {this.state.banner_list.banner ?
                      <CardMedia style={styles.bannercard}>
                        <div style={{display:'flex',justifyContent:!isMobile&&'center'}}>
                          <img id="banner" src={this.state.banner_list.banner} alt="" width="100" height="100"></img>
                          <button onClick={() => this.handledeleteBanner('banner')}><i className="fa fa-times" aria-hidden="true" style={{color:'red',marginLeft:'5%'}}> </i></button>
                        </div>
                      </CardMedia>
                      :
                      <CardMedia style={styles.bannercard}>
                        <div>Banner 1 not uploaded</div>
                      </CardMedia>
                    }
                  </div>
                  <div style={{padding:'3%'}}>
                    {!this.state.banner_list.banner_extra_1&&<input type="file" style={{width:'80%'}} name="banner_extra_1" onChange={(e) => this.handleFile(e)}/>}
                    {this.state.banner_list.banner_extra_1?
                      <CardMedia style={styles.bannercard}>
                        <div style={{display:'flex'}}>
                          <img id="banner_one" src={this.state.banner_list.banner_extra_1} alt="" width="100" height="100"></img>
                          <button onClick={() => this.handledeleteBanner('banner_one')}><i className="fa fa-times" aria-hidden="true" style={{color:'red',marginLeft:'5%'}}> </i></button>
                        </div>
                      </CardMedia>
                      :
                      <CardMedia style={styles.bannercard}>
                        <div>Banner 2 not uploaded</div>
                      </CardMedia>
                    }
                  </div>
                </div>
                <div style={{display:!isMobile&&'flex'}}>
                  <div style={{padding:'3%'}}>
                    {!this.state.banner_list.banner_extra_2&&<input type="file" style={{width:'80%'}} name="banner_extra_2" onChange={(e) => this.handleFile(e)}/>}
                    {this.state.banner_list.banner_extra_2?
                      <CardMedia style={styles.bannercard}>
                        <div style={{display:'flex'}}>
                          <img id="banner_two" src={this.state.banner_list.banner_extra_2} alt="" width="100" height="100"></img>
                          <button onClick={() => this.handledeleteBanner('banner_two')}><i className="fa fa-times" aria-hidden="true" style={{color:'red',marginLeft:'5%'}}> </i></button>
                        </div>
                      </CardMedia>
                      :
                      <CardMedia style={styles.bannercard}>
                        <div>Banner 3 not uploaded</div>
                      </CardMedia>
                    }
                  </div>
                  <div style={{padding:'3%'}}>
                    {!this.state.banner_list.banner_extra_3&&<input type="file" style={{width:'80%'}} name="banner_extra_3" onChange={(e) => this.handleFile(e)}/>}
                    {this.state.banner_list.banner_extra_3?
                      <CardMedia style={styles.bannercard}>
                        <div style={{display:'flex'}}>
                          <img id="banner_three" src={this.state.banner_list.banner_extra_3} alt="" width="100" height="100"></img>
                          <button onClick={() => this.handledeleteBanner('banner_three')}><i className="fa fa-times" aria-hidden="true" style={{color:'red',marginLeft:'5%'}}> </i></button>
                        </div>
                      </CardMedia>
                      :
                      <CardMedia style={styles.bannercard}>
                        <div>Banner 4 not uploaded</div>
                      </CardMedia>
                    }
                  </div>
                </div>
              </div>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Description
              </div>
              <textarea rows="4" cols="33" style={styles.input} id="description" name="description" placeholder="Description"
                onChange={this.handleChange}>
                {this.state.tournament_details.description}
                </textarea>
            </div>
            {this.state.tournament_series&&
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                 Tournament Series
              </div>
              <select name="edition" id="edition" className="col-md-5" style={styles.item_body} value={this.state.value}
                onChange={(e) =>{this.handleSeries(e)}}>
                <option key={-1} value={null}>----Select----</option>
                {
                  Object.keys(this.state.tournament_series).map((key, index) => (
                  <option key={index} value={this.state.tournament_series[key].id}>{this.state.tournament_series[key].name}</option>
                  ))
                }
              </select>              
            </div>
          }
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration Form Additional Fields(if any)
              </div>
              <input type="text" style={styles.input} name="additional_field" className="col-md-6 required" placeholder="Example: cities"
                value={this.state.value} onChange={this.handleChange}/>
            </div>

            {/*<div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Partners 
              </div>
              <textarea rows="2" cols="33" style={styles.input}  name="partners" placeholder=" Tournament Partners"
                onChange={this.handleChange} />
            </div>*/}

            {/*<div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration Contact Number
              </div>
              <input type="number" style={styles.input} name="registration_contact_number" className="required"
                value={this.state.value} onChange={this.handleChange}/>
            </div>*/}

            
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Online Registration
              </div>
             <input type="checkbox"
                    checked={this.state.tournament_details.online_registration_enabled}
                    ref="online_registration_enabled"
                    name="online_registration_enabled"
                    onChange={this.handleCheck}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Free Event
              </div>
             <input type="checkbox"
                    checked={this.state.tournament_details.pay_later}
                    ref="pay_later"
                    name="pay_later"
                    onChange={this.handleCheck}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Publish
              </div>
             <input type="checkbox"
                    checked={this.state.tournament_details.is_visible}
                    ref="is_visible"
                    name="is_visible"
                    onChange={this.handleCheck}/>
            </div>

            
            <div style={styles.button_submit} className="col-md-12">
              <input type="button" value="Submit" style={styles.eventbutton1} onClick={(e) => {this.handleSubmit(e)}}/>
              <p className="pull-right" style={{justifyContent:'center'}}>* Fields are Mandatory!!</p>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default AddTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournament/index.js